<div class="d-lg-flex flex-wrap align-items-center pt-1" rt="inventory-private-images-header">
  <h3>Private Photos</h3>
</div>
<div class="font-weight-light" *ngIf="!hideInlineVerificationHint">
  This is required and will not be shown on your listing.
</div>
<div class="row">
  <div class="col-lg-6 col-xl-3 mt-3" *ngFor="let image of images; index as i">
    <div class="card">
      <div class="card-header d-flex">
        <div>
          {{ image.name }}
          <ng-container *ngIf="i == 0"
            >(<a class="mb-3" href="https://company.rubbl.com/pubweb/marketplace/images/images/serial-back-plate.jpg">example</a>)</ng-container
          >
        </div>
        <div class="ml-auto" *ngIf="imagePaths[i] != '' && imagePaths[i] != null">
          <div *ngIf="!hideDropdownActions" ngbDropdown placement="bottom-right" class="d-inline-block">
            <i class="icon-peapod text-green cursor-pointer" ngbDropdownToggle></i>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="editImage(image, i)">Edit</button>
              <button ngbDropdownItem (click)="deleteImage(i)">Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <img class="w-100 img-fit br-5" *ngIf="imagePaths[i] != '' && imagePaths[i] != null" [src]="imagePaths[i]" [attr.alt]="'Machine photo ' + (i + 1)" (load)="imgOnLoad($event)" />
        <div
          *ngIf="imagePaths[i] == '' || imagePaths[i] == null"
          class="d-flex justify-content-center align-items-center image-thumbnail-add"
          (click)="singleImageInput.value = null; setIndexForImage(i); singleImageInput.click()"
        >
          <figure>
            <i class="icon-large icon-stepper-add text-light-grey ml-3 mr-1 cursor-pointer text-green" rt="upload-image-component-add-image"></i>
            <figcaption>Add Photo</figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>

  <input class="d-none" type="file" accept="image/*" (change)="onSingleImageChange($event)" #singleImageInput />
</div>
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="modal.dismiss()">Close</button>
    <button type="button" class="btn btn-secondary" (click)="saveCroppedPhoto(modal)">Save photo</button>
  </div>

  <img style="max-width: 100%" [src]="imgCropperSrc" id="croppr" #croppr alt="Image to crop" (load)="imageLoadedForCropper($event)" />

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="zoomOut()">Zoom Out</button>
    <button type="button" class="btn btn-outline-secondary" (click)="zoomIn()">Zoom In</button>
  </div>
</ng-template>
